/**
 * Minimal client check only — no libphonenumber (its metadata is not always up to date).
 * Accepts international-style values from PhoneInput (+ then digits). Server remains authoritative.
 */
export function isPlausibleInternationalPhone(value: string | undefined | null): boolean {
  const s = String(value ?? '').trim();
  if (!s.startsWith('+')) return false;
  const digits = s.slice(1).replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
}
